import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FilterList from '../../filterList/FilterList'
import FilterRangeSlider from '../../filtersRow/FilterRangeSlider'
import FilterSquares from '../../filtersRow/FilterSquares'
import FilterRowDropdownItem from '../../filtersRow/FilterRowDropdownItem'
import FilterSidebarLayout from '../../filtersRow/FilterSidebarLayout'
import {
  addFilter,
  removeFilter,
  clearFilter,
  clearAllFilters
} from '../../../redux/actions/planEntries'
import { isCategoryAlreadyFiltered } from './classFinderHelperMethods'
import { class_series_finder_filter_event } from 'gtm/pushEvents'

class ClassFinderMobileFilters extends React.Component {
  constructor(props) {
    super(props)

    this.instructorAlreadyFiltered = this.instructorAlreadyFiltered.bind(this)
    this.intensityAlreadyFiltered = this.intensityAlreadyFiltered.bind(this)
    this.categoryAlreadyFiltered = this.categoryAlreadyFiltered.bind(this)
    this.difficultyAlreadyFiltered = this.difficultyAlreadyFiltered.bind(this)
    this.noInstructorsFiltered = this.noInstructorsFiltered.bind(this)
  }

  noInstructorsFiltered() {
    return this.props.filtered?.instructors?.length === 0
  }

  instructorAlreadyFiltered(instructor) {
    return this.props.filtered?.instructors
      ?.map((instructor) => instructor.slug)
      ?.includes(instructor.slug)
  }

  intensityAlreadyFiltered(intensityLevel) {
    return this.props.filtered?.intensities
      .map((intensity) => intensity.level)
      .includes(intensityLevel)
  }

  difficultyAlreadyFiltered(difficulty) {
    return this.props.filtered?.difficulties?.includes(difficulty)
  }

  categoryAlreadyFiltered(root, { isRoot, subcategory }) {
    return isCategoryAlreadyFiltered(
      this.props.filtered?.styles,
      root,
      isRoot,
      subcategory
    )
  }

  buildCategoryFilters() {
    const filterOptions = this.props.filterOptions
    let categoryFilters = []

    for (const rootCategory in filterOptions.styles) {
      const categoryObj = filterOptions.styles[rootCategory]

      const filterObj = {
        label: categoryObj.title,
        value: categoryObj,
        isAllSelected: this.categoryAlreadyFiltered(categoryObj, {
          isRoot: true
        }),
        subFilters: categoryObj.subcategories.map((subcategory) => {
          return {
            label: subcategory.title,
            value: subcategory,
            active: this.categoryAlreadyFiltered(categoryObj, {
              isRoot: false,
              subcategory
            })
          }
        })
      }
      categoryFilters.push(filterObj)
    }

    return categoryFilters
  }

  render() {
    const {
      filterOptions,
      sliderProps,
      filteredLabels,
      filtered,
      filterByFields,
      ...rest
    } = this.props

    const durationFilter = {
      label: 'duration',
      filteredLabels: filteredLabels.duration.map((duration) => duration.text),
      content: (touchList) => {
        return (
          <FilterRangeSlider
            {...sliderProps}
            lightVersion
            allowOverMax
            step={10}
            onSlideEnd={(newDurationMinMax) => {
              rest.addFilter('duration', newDurationMinMax)
              touchList()
            }}
          />
        )
      }
    }

    let instructorFilter
    if (!rest.noInstructors) {
      instructorFilter = {
        label: 'instructors',
        isFullscreen: true,
        filteredLabels: filteredLabels?.instructors?.map(
          (instructor) => instructor.text
        ),
        content: (touchList) => {
          return (
            <React.Fragment>
              <FilterRowDropdownItem
                key={0}
                label='All Instructors'
                activeLinkColor='#FFFFFF'
                linkStyles={{
                  color: '#FFFFFF'
                }}
                itemStyles={{
                  padding: '10px 0',
                  color: '#FFF'
                }}
                handleItemClick={() => {
                  rest.clearInstructorFilter()
                  touchList()
                }}
                active={this.noInstructorsFiltered()}
              />
              {filterOptions?.instructors?.map((option, idx) => {
                const alreadyFiltered = this.instructorAlreadyFiltered(option)
                return (
                  <FilterRowDropdownItem
                    key={idx + 1}
                    active={alreadyFiltered}
                    label={`${option.user.firstName} ${option.user.lastName}`}
                    linkStyles={{
                      color: '#FFFFFF'
                    }}
                    activeLinkColor='#FFFFFF'
                    itemStyles={{
                      padding: '10px 0',
                      color: '#FFF'
                    }}
                    handleItemClick={() => {
                      if (alreadyFiltered) {
                        rest.removeFilter(
                          'instructors',
                          option.slug,
                          filterByFields.instructors
                        )
                      } else {
                        rest.addFilter('instructors', option)
                      }
                      touchList()
                    }}
                  />
                )
              })}
            </React.Fragment>
          )
        }
      }
    }

    const styleFilter = {
      label: 'styles',
      isFullscreen: true,
      filteredLabels: filteredLabels.styles.map((label) => label.text),
      content: (touchList) => {
        if (this.props.withSubcategories) {
          return (
            <FilterSidebarLayout
              filterOptions={this.buildCategoryFilters()}
              onSelect={({ parent: rootCategory, child: subcategory }) => {
                const root = {
                  title: rootCategory ? rootCategory.title : subcategory.title,
                  slug: rootCategory ? rootCategory.slug : subcategory.slug
                }
                const rootCategorySelected = subcategory === 'all'

                const categoryToToggle = rootCategorySelected
                  ? rootCategory
                  : subcategory

                if (
                  this.categoryAlreadyFiltered(root, {
                    isRoot: rootCategorySelected,
                    subcategory: categoryToToggle
                  })
                ) {
                  rest.removeFilter('styles', categoryToToggle.slug, 'slug', {
                    rootSlug: root.slug,
                    isRoot: rootCategorySelected
                  })
                } else {
                  rest.addFilter('styles', categoryToToggle, {
                    root: rootCategory,
                    isRoot: rootCategorySelected
                  })
                }
                touchList()
              }}
            />
          )
        } else {
          // Temporary so that page will still work even when no subcategories have been listed.  This needs to be taken out
          // when all subcategories have gone live.
          return (
            <React.Fragment>
              {filterOptions.styles.map((option, idx) => {
                const alreadyFiltered = this.categoryAlreadyFiltered(option, {
                  isRoot: true,
                  subcategory: option
                })
                return (
                  <FilterRowDropdownItem
                    key={idx}
                    active={alreadyFiltered}
                    label={`${option.title}`}
                    activeLinkColor='#FFFFFF'
                    linkStyles={{
                      color: '#FFFFFF'
                    }}
                    itemStyles={{
                      padding: '10px 0',
                      color: '#FFF'
                    }}
                    handleItemClick={() => {
                      if (alreadyFiltered) {
                        rest.removeFilter(
                          'styles',
                          option.slug,
                          filterByFields.styles,
                          {
                            isRoot: true,
                            root: option
                          }
                        )
                      } else {
                        rest.addFilter('styles', option, {
                          isRoot: true,
                          root: option
                        })
                      }
                      touchList()
                    }}
                  />
                )
              })}
            </React.Fragment>
          )
        }
      }
    }

    const intensityFilter = {
      label: 'intensity',
      filteredLabels: filteredLabels.intensities.map(
        (intensity) => intensity.text
      ),
      content: (touchList) => {
        return (
          <FilterSquares
            onSelect={({ option: intensity }) => {
              if (this.intensityAlreadyFiltered(intensity.level)) {
                rest.removeFilter(
                  'intensities',
                  intensity.level,
                  filterByFields.intensities
                )
              } else {
                rest.addFilter('intensities', intensity)
              }
              touchList()
            }}
            filterOptions={filterOptions.intensities.map((intensity) => ({
              label: intensity.level,
              obj: intensity,
              active: this.intensityAlreadyFiltered(intensity.level)
            }))}
          />
        )
      }
    }

    const difficultyFilter = {
      label: 'difficulty',
      filteredLabels: filteredLabels.difficulties?.map(
        (difficulty) => difficulty.text
      ),
      content: (touchList) => {
        return (
          <FilterSquares
            rectangleVersion
            numSquaresPerRow={2}
            onSelect={({ option: difficulty }) => {
              if (this.difficultyAlreadyFiltered(difficulty)) {
                rest.removeFilter('difficulties', difficulty)
              } else {
                rest.addFilter('difficulties', difficulty)
              }
              touchList()
            }}
            filterOptions={filterOptions.difficulties?.map((difficulty) => ({
              label: difficulty,
              active: this.difficultyAlreadyFiltered(difficulty)
            }))}
          />
        )
      }
    }

    let filterListOptions = instructorFilter ? [instructorFilter] : []

    filterListOptions = [
      ...filterListOptions,
      durationFilter,
      difficultyFilter,
      intensityFilter,
      styleFilter
    ]

    const filterListProps = {
      ...rest,
      filterListOptions,
      filteredLabels,
      onReset: rest.clearAllFilters
    }
    return <FilterList {...filterListProps} />
  }
}

ClassFinderMobileFilters.propTypes = {
  onHide: PropTypes.func,
  isOpen: PropTypes.bool,
  filterOptions: PropTypes.object,
  filteredLabels: PropTypes.object,
  sliderProps: PropTypes.object,
  addFilter: PropTypes.func,
  removeFilter: PropTypes.func,
  filtered: PropTypes.object,
  filterByFields: PropTypes.object,
  withSubcategories: PropTypes.bool,
  clearInstructorFilter: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    filtered: state.ui.planEntries.filtered
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addFilter: (filterSection, filter, options) => {
      const minValue = filter?.min || 0
      const maxValue = filter?.max || 90
      let filterValue = ''
      const hideEvent =
        filterSection === 'duration' && minValue === 0 && maxValue === 90

      if (!hideEvent) {
        switch (filterSection) {
          case 'instructors':
            filterValue = filter?.user?.name
            break
          case 'styles':
            filterValue = filter?.slug
            break
          case 'intensities':
            filterValue = String(filter?.level)
            break
          case 'duration':
            filterValue = `${minValue}-${maxValue}`
            break
          case 'difficulties':
            filterValue = filter
            break
          default:
            filterValue = filter
            break
        }
      }
      !hideEvent &&
        class_series_finder_filter_event(filterSection, filterValue, options)
      dispatch(addFilter(filterSection, filter, options))
    },
    removeFilter: (filterSection, filter, filterField, options) => {
      dispatch(removeFilter(filterSection, filter, filterField, options))
    },
    clearInstructorFilter: () => {
      dispatch(clearFilter('instructors'))
    },
    clearAllFilters: () => {
      dispatch(clearAllFilters())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassFinderMobileFilters)
